<template>
    <div class="container">
        <content-header title="Страничка офтальмолога"/>
        <p style="font-size: 16px; text-align: center;"><span class="bold">ДОБРО ПОЖАЛОВАТЬ!</span></p>
        <p style="font-size: 16px; text-indent: 20px"><span class="bold">«Хранить, как зеницу ока»</span> — очень верная
            народная мудрость. Видеть
            мир и наслаждаться его красотой, любоваться тем, что нам дорого – это величайшая ценность человека. Зрение
            дает нам 80% информации об окружающем мире, а глаза отражают все то, что мы чувствуем: радость, любовь,
            равнодушие, гнев… Они — зеркало души.</p>
        <p style="font-size: 16px; text-indent: 20px">Многолетний опыт, высококвалифицированные специалисты, современное
            оборудование и новейшие методы лечения в компании с искренней любовью и заботой в сердце каждого сотрудника
            нашего коллектива дают исключительные результаты. Наша цель- сделать Ваши глаза здоровыми!</p>
        <p style="font-size: 16px; text-align: center;"><span class="bold">Мы храним Ваши глаза, Вашу полноценную жизнь, «как зеницу ока»!</span>
        </p>
        <div class="inv-divider"></div>
        <div class="flex">
            <div class="box"><img src="../../assets/images/staticPages/BNR_OHG.jpg" alt="BNR_OHG" width="310"/>
                <p>ОФТАЛЬМОХИРУРГИЯ</p>
            </div>
            <div class="box"><img src="../../assets/images/staticPages/oft_bol.jpg" alt="oft_bol" width="310"/>
                <p>БОЛЬ В ГЛАЗАХ</p>
            </div>
            <div class="box"><img src="../../assets/images/staticPages/oft_glau.jpg" alt="oft_glau" width="310"/>
                <p>ГЛАУКОМА</p>
            </div>
        </div>
        <div class="inv-divider"></div>
        <div class="flex">
            <div class="box"><img src="../../assets/images/staticPages/oft_pc.png" alt="oft_pc" width="310"/>
                <p>УСТАЛОСТЬ ГЛАЗ ОТ КОМПЬЮТЕРА</p>
            </div>
            <div class="box"><img src="../../assets/images/staticPages/oft_hal.jpg" alt="oft_hal" width="310"/>
                <p>ХАЛЯЗИОН</p>
            </div>
            <div class="box"><img src="../../assets/images/staticPages/oft_sltch.png" alt="oft_sltch" width="310"/>
                <p>СЛЕЗОТЕЧЕНИЕ</p>
            </div>
        </div>
        <div class="inv-divider"></div>
        <div class="flex">
            <div class="box"><img src="../../assets/images/staticPages/oft_ktln.png" alt="oft_ktln" width="310"/>
                <p>КОНТАКТНЫЕ ЛИНЗЫ</p>
            </div>
            <div class="box"><img src="../../assets/images/staticPages/oft_zbglz.png" alt="oft_zbglz" width="310"/>
                <p>ВОСПАЛИТЕЛЬНЫЕ ЗАБОЛЕВАНИЯ</p>
            </div>
            <div class="box"><img src="../../assets/images/staticPages/katarakta.jpg" alt="katarakta" width="310"/>
                <p>КАТАРАКТА</p>
            </div>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";

export default {
    name: "ophthalmology",
    components: {
        ContentHeader
    },
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 310px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

</style>
